export const PUSH_STATE = 'pushstate';

export const REPLACE_STATE = 'replacestate';
